(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-product-card"] && !Shopify.designMode) return;
  try {
    /* Hover-image warm-up - see the .cpc__photo-hover rule. A mouse or pen entering
     any part of a card (photo, name, price) flips that card's lazy hover image to
     eager, so the fetch starts before or as the photo is hovered. Per card, not per
     grid: the pointer sits over the grid most of the time on a collection page, and
     warming every card would bring back the up-front download. Touch never warms
     (the image is never shown there). One delegated listener covers cards that
     Load more, filters and the theme editor add later. */
  (function () {
    if (window.__cpcHoverWarm) return;
    window.__cpcHoverWarm = true;
    var canHover = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
    document.addEventListener('pointerover', function (event) {
      if (event.pointerType === 'touch' || !canHover || !canHover.matches) return;
      var card = event.target.closest ? event.target.closest('.cpc') : null;
      var img = card && card.querySelector('.cpc__photo-hover[loading="lazy"]');
      if (img) img.setAttribute('loading', 'eager');
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__drawerInit) return;
  window.__drawerInit = true;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var triggerEl = null;
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  // Cancel a close that is still waiting to hide this panel (reopened mid-slide).
  function cancelHide(panel) {
    if (panel && panel.__drawerCancelHide) panel.__drawerCancelHide();
  }

  // Re-hide a closed panel once its slide-out has finished. transitionend is the
  // signal; the timeout (the panel's own transition time + slack) covers a
  // transition that never runs or never reports, e.g. a background tab.
  function hideAfterSlide(panel) {
    cancelHide(panel);
    if (reduceMotion && reduceMotion.matches) {
      panel.hidden = true;
      return;
    }
    var duration = getComputedStyle(panel).transitionDuration.split(',')[0].trim();
    var ms = (parseFloat(duration) || 0) * (/ms$/.test(duration) ? 1 : 1000);
    var timer = null;
    function done(e) {
      if (e && (e.target !== panel || e.propertyName !== 'transform')) return;
      panel.__drawerCancelHide();
      if (!panel.classList.contains('open')) panel.hidden = true;
    }
    panel.__drawerCancelHide = function () {
      clearTimeout(timer);
      panel.removeEventListener('transitionend', done);
      panel.__drawerCancelHide = null;
    };
    panel.addEventListener('transitionend', done);
    timer = setTimeout(done, ms + 100);
  }

  // Every copy of a drawer's panel / overlay, in document order. Compared as
  // strings, so an id never has to be escaped into a selector.
  function copies(selector, attr, id) {
    return Array.prototype.filter.call(document.querySelectorAll(selector), function (el) {
      return el.getAttribute(attr) === id;
    });
  }

  // The copy to open: one still inside its section (the latest render, the one
  // that section's script just bound to) beats one parked in <body> by an
  // earlier open. See the header comment.
  function current(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].parentNode !== document.body) return list[i];
    }
    return list[0] || null;
  }

  // Remove the stale copies an earlier open left in <body>, so ids (and the
  // labels and inputs inside the drawer) are unique again.
  function dropStale(list, keep) {
    list.forEach(function (el) {
      if (el === keep || el.parentNode !== document.body) return;
      cancelHide(el);
      document.body.removeChild(el);
    });
  }

  window.__openDrawer = function (id) {
    var panels = copies('.drawer-panel', 'id', id);
    var overlays = copies('.drawer-overlay', 'data-drawer-id', id);
    var panel = current(panels);
    var overlay = current(overlays);
    dropStale(panels, panel);
    dropStale(overlays, overlay);
    // Portal to <body> so the fixed-position drawer escapes any sticky/transformed
    // ancestor (e.g. the sticky filter bar) that would otherwise trap its stacking
    // context below the header. Idempotent: only moves on first open.
    if (overlay && overlay.parentNode !== document.body) document.body.appendChild(overlay);
    if (panel && panel.parentNode !== document.body) document.body.appendChild(panel);
    triggerEl = document.activeElement;
    // A closed panel is display: none (see the header comment). Un-hide it
    // BEFORE the reflow below, so that reflow is what lays it out at its
    // off-screen start state.
    if (panel) {
      cancelHide(panel);
      panel.hidden = false;
    }
    // Flush layout after the (re)portal to <body> so the panel/overlay paint at
    // their off-screen start state before .open is added. Without this, the move
    // and the class change batch into a single frame and the slide-in is skipped
    // on the FIRST open (later opens animate only because the node is already in
    // <body> and no longer moves).
    if (panel) panel.getBoundingClientRect();
    else if (overlay) overlay.getBoundingClientRect();
    if (panel) {
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
      var first = panel.querySelector(FOCUSABLE);
      if (first) setTimeout(function () { first.focus(); }, 100);
    }
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.__closeDrawer = function (id) {
    // Every copy, not the first by id: that one can be a stale, already-closed
    // copy while the open one sits later in <body>.
    copies('.drawer-panel', 'id', id).forEach(function (panel) {
      if (panel.hidden) return;
      panel.classList.remove('open');
      panel.setAttribute('aria-hidden', 'true');
      hideAfterSlide(panel);
    });
    copies('.drawer-overlay', 'data-drawer-id', id).forEach(function (overlay) {
      overlay.classList.remove('open');
    });
    document.body.style.overflow = '';
    if (triggerEl) {
      triggerEl.focus();
      triggerEl = null;
    }
  };

  document.addEventListener('click', function (e) {
    var overlay = e.target.closest('.drawer-overlay');
    if (overlay) {
      window.__closeDrawer(overlay.getAttribute('data-drawer-id'));
      return;
    }
    var closeBtn = e.target.closest('.drawer-close');
    if (closeBtn) {
      var panel = closeBtn.closest('.drawer-panel');
      if (panel) window.__closeDrawer(panel.id);
    }
  });

  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('.drawer-panel.open');
    if (!open) return;

    if (e.key === 'Escape') {
      window.__closeDrawer(open.id);
      return;
    }

    if (e.key === 'Tab') {
      var focusable = Array.prototype.slice.call(open.querySelectorAll(FOCUSABLE));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-comparison"] && !Shopify.designMode) return;
  try {
    (function () {
  /* Per-size spec data, merged from every comparison's #mc-size-data, including
     one that arrives later through the deferred load below. */
  var sizeData = {};

  function readSizeData(scope) {
    scope.querySelectorAll('script[id="mc-size-data"]').forEach(function (el) {
      var data;
      try { data = JSON.parse(el.textContent); } catch (e) { return; }
      for (var k in data) sizeData[k] = data[k];
    });
  }

  function getVariantMap(card) {
    try { return JSON.parse(card.getAttribute('data-variant-data') || '{}'); } catch (e) { return {}; }
  }

  function getActiveSize(card) {
    var btn = card.querySelector('.mc__card-size-btn.is-active');
    return btn ? btn.dataset.mcCardSize : '';
  }

  function getActiveColor(card) {
    var btn = card.querySelector('.mc__swatch-btn.is-active:not([disabled])');
    return btn ? btn.dataset.mcColor.toLowerCase() : '';
  }

  // Finds this colour at this size, else any variant of the colour - same
  // fallback the image lookup already used before price was added.
  function findVariantEntry(map, color, size) {
    var key = color + '|' + size;
    if (map[key]) return map[key];
    for (var k in map) {
      if (k.indexOf(color + '|') === 0 && map[k]) return map[k];
    }
    return null;
  }

  function updateCardImage(card, color, size) {
    var img = card.querySelector('.mc__photo');
    if (!img) return;
    var entry = findVariantEntry(getVariantMap(card), color, size);
    if (entry && entry.image) {
      img.setAttribute('src', entry.image);
      img.setAttribute('srcset', '');
      return;
    }
    var fallback = card.getAttribute('data-default-image');
    if (fallback) {
      img.setAttribute('src', fallback);
      img.setAttribute('srcset', '');
    }
  }

  // A clicked colour or size is an explicit choice, so both the card's own
  // price and its row in the spec table below must reflect that exact
  // variant - mirrors the collection-card swatch click in
  // snippets/collection-product-card.liquid.
  function updateCardPrice(card, color, size) {
    var entry = findVariantEntry(getVariantMap(card), color, size);
    // Price markup is pre-rendered by Liquid through snippets/price.liquid.
    var priceHtml = entry && entry.priceHtml ? entry.priceHtml : card.getAttribute('data-default-price-html');
    if (!priceHtml) return;

    var priceEl = card.querySelector('.mc__price');
    if (priceEl) priceEl.innerHTML = priceHtml;

    var handle = card.dataset.mcHandle;
    if (handle) {
      var tableEl = document.querySelector('[data-mc-handle="' + handle + '"][data-mc-field="price"]');
      if (tableEl) tableEl.innerHTML = priceHtml;
    }
  }


  // The quick-add form renders with the card's default variant id, so without
  // this the button adds that default no matter which swatch or size is on
  // screen. Resolved through findVariantEntry so the id can never disagree
  // with the photo and price the same lookup just set.
  function updateCardVariantId(card, color, size) {
    var idInput = card.querySelector('.mc__form input[name="id"]');
    if (!idInput) return;
    var entry = findVariantEntry(getVariantMap(card), color, size);
    if (entry && entry.id) idInput.value = entry.id;
  }

  function updateTableValues(handle, size) {
    var pd = sizeData[handle];
    ['dimensions', 'volume', 'weight'].forEach(function (field) {
      var el = document.querySelector('[data-mc-handle="' + handle + '"][data-mc-field="' + field + '"]');
      if (!el) return;
      if (pd && pd[size]) {
        el.textContent = pd[size][field] || '-';
      } else {
        el.textContent = '-';
      }
    });
  }

  function updateSwatchStates(card, size) {
    var map = getVariantMap(card);
    var activeBtn = card.querySelector('.mc__swatch-btn.is-active');
    var activeDisabled = false;
    card.querySelectorAll('.mc__swatch-btn').forEach(function (btn) {
      var color = btn.dataset.mcColor.toLowerCase();
      var key = color + '|' + size;
      var has = key in map;
      btn.disabled = !has;
      if (btn === activeBtn && !has) activeDisabled = true;
    });
    if (activeDisabled) {
      var first = card.querySelector('.mc__swatch-btn:not([disabled])');
      if (first) {
        card.querySelectorAll('.mc__swatch-btn').forEach(function (b) { b.classList.remove('is-active'); });
        first.classList.add('is-active');
        updateCardImage(card, first.dataset.mcColor.toLowerCase(), size);
        updateCardPrice(card, first.dataset.mcColor.toLowerCase(), size);
        updateCardVariantId(card, first.dataset.mcColor.toLowerCase(), size);
      }
    }
  }

  function updateSizeStates(card, color) {
    var map = getVariantMap(card);
    var activeBtn = card.querySelector('.mc__card-size-btn.is-active');
    var activeDisabled = false;
    card.querySelectorAll('.mc__card-size-btn').forEach(function (btn) {
      var size = btn.dataset.mcCardSize;
      var key = color + '|' + size;
      var has = key in map;
      btn.disabled = !has;
      if (btn === activeBtn && !has) activeDisabled = true;
    });
    if (activeDisabled) {
      var first = card.querySelector('.mc__card-size-btn:not([disabled])');
      if (first) {
        card.querySelectorAll('.mc__card-size-btn').forEach(function (b) { b.classList.remove('is-active'); });
        first.classList.add('is-active');
        var handle = first.dataset.mcHandle;
        updateTableValues(handle, first.dataset.mcCardSize);
      }
    }
  }

  // Host PDP colour onto every card in scope (document, or a comparison that
  // has just arrived).
  function applyColor(scope, color) {
    scope.querySelectorAll('.mc__card').forEach(function (card) {
      var size = getActiveSize(card);
      var map = getVariantMap(card);
      var key = color + '|' + size;
      var swatches = card.querySelectorAll('.mc__swatch-btn');
      if (swatches.length > 0 && key in map) {
        swatches.forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.mcColor.toLowerCase() === color);
        });
        updateSizeStates(card, color);
        size = getActiveSize(card);
      }
      updateCardImage(card, color, size);
      updateCardPrice(card, color, size);
      updateCardVariantId(card, color, size);
    });
  }

  // Color swatch image switching (via PDP color change event)
  document.addEventListener('pdp:color-change', function (e) {
    applyColor(document, e.detail.color.toLowerCase());
  });

  // Wires one rendered comparison (.mc with its cards and table). Once per
  // element: the initial pass, a deferred load and a theme-editor reload can
  // all reach the same .mc.
  function bind(root) {
    if (root.__mcBound) return;
    root.__mcBound = true;
    readSizeData(root);

    // Per-card size switcher
    root.querySelectorAll('.mc__card-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.mcHandle;
        var size = btn.dataset.mcCardSize;
        var card = btn.closest('.mc__card');

        if (card) {
          card.querySelectorAll('.mc__card-size-btn').forEach(function (b) {
            b.classList.toggle('is-active', b.dataset.mcCardSize === size);
          });

          updateSwatchStates(card, size);

          var color = getActiveColor(card);
          if (color) {
            updateSizeStates(card, color);
            updateCardImage(card, color, size);
            updateCardPrice(card, color, size);
            updateCardVariantId(card, color, size);
          } else {
            // No colour swatches on this product - fall back to the per-size
            // (not per-colour|size) data already used for dimensions/volume/weight.
            var sd = sizeData[handle] && sizeData[handle][size];
            if (sd && sd.image) {
              var img = card.querySelector('.mc__photo');
              if (img) {
                img.setAttribute('src', sd.image);
                img.setAttribute('srcset', '');
              }
            }
            if (sd && sd.priceHtml) {
              var priceEl = card.querySelector('.mc__price');
              if (priceEl) priceEl.innerHTML = sd.priceHtml;
              var tableEl = document.querySelector('[data-mc-handle="' + handle + '"][data-mc-field="price"]');
              if (tableEl) tableEl.innerHTML = sd.priceHtml;
            }
          }
        }

        updateTableValues(handle, size);
      });
    });

    // Individual swatch click
    root.querySelectorAll('.mc__swatch-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.mc__card');
        if (!card) return;
        var color = btn.dataset.mcColor.toLowerCase();

        card.querySelectorAll('.mc__swatch-btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        updateSizeStates(card, color);
        var size = getActiveSize(card);
        updateCardImage(card, color, size);
        updateCardPrice(card, color, size);
        updateCardVariantId(card, color, size);
      });
    });

    // Add-to-cart handling
    root.querySelectorAll('.mc__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.mc__add-btn');
        var plus = btn.querySelector('[data-qa-plus]');
        btn.disabled = true;

        function resetBtn() {
          if (plus) plus.textContent = '+';
          btn.disabled = false;
        }

        var cartUrl = form.closest('.mc').dataset.cartAddUrl || '/cart/add';
        fetch(cartUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(form.querySelector('[name="id"]').value),
              quantity: 1
            }]
          })
        })
        .then(function (res) {
          if (!res.ok) throw new Error(res.statusText);
          return res.json();
        })
        .then(function () {
          if (plus) plus.textContent = '✓';
          setTimeout(resetBtn, 1500);
        })
        .catch(function () {
          if (plus) plus.textContent = '!';
          setTimeout(resetBtn, 1500);
        });
      });
    });

    // Sync horizontal scroll between card row and table
    var grid = root.querySelector('.mc__grid');
    var table = root.querySelector('.mc__table');
    if (grid && table) {
      var syncing = false;
      var syncScroll = function (source, target) {
        if (syncing) return;
        syncing = true;
        var maxS = source.scrollWidth - source.clientWidth;
        var maxT = target.scrollWidth - target.clientWidth;
        if (maxS > 0 && maxT > 0) {
          target.scrollLeft = (source.scrollLeft / maxS) * maxT;
        }
        syncing = false;
      };
      grid.addEventListener('scroll', function () { syncScroll(grid, table); });
      table.addEventListener('scroll', function () { syncScroll(table, grid); });
    }

    // Initialize disabled states based on default selections
    root.querySelectorAll('.mc__card').forEach(function (card) {
      var size = getActiveSize(card);
      if (size) updateSwatchStates(card, size);
      var color = getActiveColor(card);
      if (color) updateSizeStates(card, color);
    });
  }

  /* ---- Deferred comparison (defer_url, the PDP) ----------------------------
     The shell is fetched from data-mc-src as the section comes within 1500px of
     the viewport (above or below, so a jump to #reviews past it also loads it),
     on the first Tab, or when its sentinel takes focus, then wired exactly like
     an inline render and given the PDP's current colour, which the load-time
     pdp:color-change could not reach. */
  function currentPdpColor() {
    var active = document.querySelector('.swatch-btn.is-active');
    return active && active.dataset.color ? active.dataset.color.toLowerCase() : '';
  }

  function settle(mc) {
    mc.removeAttribute('data-mc-src');
    mc.removeAttribute('aria-busy');
    mc.classList.remove('mc--deferred', 'mc--loading');
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // First rendered focusable in the comparison, in tab order.
  function firstFocusable(mc) {
    var all = mc.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < all.length; i++) {
      if (all[i].getClientRects().length) return all[i];
    }
    return null;
  }

  // Swap the slot for new content. When the section's top is above the
  // viewport (a jump to #reviews, or the footer reached first), the shopper is
  // reading what sits below the slot, so the scroll position absorbs the
  // height change instead of pushing that content - with the browser's own
  // scroll anchoring off for that one swap, or it would be corrected twice.
  // Returns whether focus was inside the slot (a keyboard user waiting on its
  // sentinel), so the caller can move it on once the new content is wired.
  function swapSlot(mc, nodes) {
    var slot = mc.querySelector('[data-mc-slot]');
    if (!slot) return false;
    var refocus = slot.contains(document.activeElement);
    var before = mc.getBoundingClientRect();
    var above = before.top < 0;
    var scroller = document.scrollingElement || document.documentElement;
    var anchor = scroller.style.overflowAnchor;
    if (above) scroller.style.overflowAnchor = 'none';
    nodes.forEach(function (n) { slot.parentNode.insertBefore(n, slot); });
    slot.parentNode.removeChild(slot);
    settle(mc);
    if (above) {
      var delta = mc.getBoundingClientRect().height - before.height;
      if (delta) window.scrollBy(0, delta);
      requestAnimationFrame(function () { scroller.style.overflowAnchor = anchor; });
    }
    return refocus;
  }

  // The forward tab order carries on into what replaced the slot.
  function focusFirst(mc) {
    var next = firstFocusable(mc);
    if (next) next.focus();
  }

  // The fetch failed, stalled or came back empty: show the noscript link list,
  // so every compared model is still one tap away.
  function fallback(mc) {
    var slot = mc.querySelector('[data-mc-slot]');
    if (!slot) { settle(mc); return; }
    var ns = slot.querySelector('noscript');
    var holder = document.createElement('div');
    if (ns) holder.innerHTML = ns.textContent;
    if (swapSlot(mc, Array.prototype.slice.call(holder.children))) focusFirst(mc);
  }

  // A request that stalls would hold the empty slot open for as long as the
  // connection lasts, so it is cut off after this long and the list shown.
  var LOAD_TIMEOUT = 8000;

  function load(mc) {
    if (mc.__mcLoading) return;
    mc.__mcLoading = true;
    mc.classList.add('mc--loading');
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, LOAD_TIMEOUT) : 0;
    fetch(mc.getAttribute('data-mc-src'), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        clearTimeout(timer);
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.mc');
        var parts = fresh ? fresh.querySelectorAll('.mc__inner > .mc__grid, .mc__inner > .mc__table') : [];
        if (!parts.length) throw new Error('empty comparison');
        var nodes = Array.prototype.slice.call(parts);
        var data = fresh.querySelector('script[id="mc-size-data"]');
        var refocus = swapSlot(mc, nodes);
        if (data) mc.appendChild(data);
        bind(mc);
        var color = currentPdpColor();
        if (color) applyColor(mc, color);
        // After bind + applyColor, which can disable a swatch or size button.
        if (refocus) focusFirst(mc);
      })
      .catch(function () {
        clearTimeout(timer);
        fallback(mc);
      });
  }

  function watch(mc) {
    if (mc.__mcObserved) return;
    mc.__mcObserved = true;
    var sentinel = mc.querySelector('[data-mc-sentinel]');
    if (sentinel) {
      sentinel.addEventListener('focus', function () { load(mc); });
      sentinel.addEventListener('click', function () { load(mc); });
      sentinel.hidden = false;
    }
    if (!('IntersectionObserver' in window)) { load(mc); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      load(mc);
    }, { rootMargin: '1500px 0px' });
    io.observe(mc);
  }

  function init(scope) {
    scope.querySelectorAll('.mc').forEach(function (mc) {
      if (mc.hasAttribute('data-mc-src')) watch(mc);
      else bind(mc);
    });
  }

  // Keyboard: the first Tab anywhere on the page starts every deferred load,
  // so by the time focus walks down to the comparison its cards are in the tab
  // order, as they were when they rendered inline. The sentinel covers a Tab
  // that still gets there first.
  function onFirstTab(e) {
    if (e.key !== 'Tab') return;
    document.removeEventListener('keydown', onFirstTab, true);
    document.querySelectorAll('.mc[data-mc-src]').forEach(load);
  }

  init(document);
  document.addEventListener('keydown', onFirstTab, true);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
